module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/school_connection_banner.e808a38aca8890df6efd40e5f4c0ce4e.png";